import React from 'react'
import { Link } from 'react-router-dom'

const Fail = () => {
  return (
    <div>
      <div className="payment-failed-container">
            <div className="payment-failed-content">
          
              <div className="payment-failed-header">
                <div className="payment-failed-icon-container">
                  <svg
                    className="payment-failed-icon"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
                    />
                  </svg>
                </div>
                <h1 className="payment-failed-title">Payment Failed</h1>
                <p className="payment-failed-subtitle">
                  Don't worry, it happens! Let's get you back on track.
                </p>
              </div>

              {/* Main Message */}
              <div className="payment-failed-message-card">
                <p className="payment-failed-message-text">
                  Your payment could not be processed at this time. This might
                  be due to insufficient funds, an expired card, or a
                  temporary issue with your payment method. Your account is
                  safe and no charges have been made.
                </p>
              </div>

              {/* Action Buttons */}
              <div className="payment-failed-actions">
                <button
                 
                  className="chalan-payment-button"
                >
                  <Link style={{color:"white",  }} to="/student/dashboard">
                  Go To Dashboard
                  </Link>
                  
                </button>
              </div>
            </div>
          </div>
    </div>
  )
}

export default Fail
